// Auth stuff

// TODO: We need to decide how we're going to do form validation, submission, and error handling.
// TODO: Can probably use the same code login, register, and forgot-password
// TODO: Does this re-import pristinejs every time? If so, we should probably just import it once and use it everywhere.

import './modules/password-toggle';
import './modules/phone-validation';

import './modules/auth/register';
import './modules/auth/request-invite';

document.addEventListener('DOMContentLoaded', () => {
  console.info('Hello Auth JS');
});
